import { ChevronRight } from "@mui/icons-material";
import styled from "styled-components";

export const SettingsRowChevron = styled(ChevronRight)`
  color: ${({ theme }) => theme.palette.primary.main};
`;
